import { createContext, useEffect, useState } from "react";
import CheckAuthPromise from "./utilites/checkAuth";
import loginPromise from "./utilites/login";
import logoutPromise from "./utilites/logout";
import sendCode from "./utilites/sendCode";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  /* #region  State */
  const [userDetails, setUserDetails] = useState({
    FullName: "",
    EMailID: "",
    MobileNumber: "",
    City: "",
    Country: "",
    ProfilePicture: "",
  });
  const [loggedIn, setLoggedIn] = useState(false);
  /* #endregion */

  /* #region  Auth functions */
  const loginFunc = (phone, password) =>
    new Promise((resolve, reject) => {
      loginPromise(phone, password)
        .then((response) => {
          console.log(response);
          if (response.success) {
            setUserDetails(response.user);
            setLoggedIn(true);
          } else {
            setUserDetails({
              FullName: "",
              EMailID: "",
              MobileNumber: phone,
              City: "",
              Country: "",
              ProfilePicture: "",
            });
            setLoggedIn(false);
          }
          resolve(response.success);
        })
        .catch((error) => {
          reject(error);
        });
    });
  const logoutFunc = () =>
    new Promise((resolve, reject) => {
      logoutPromise()
        .then(() => {
          setLoggedIn(false);
          setUserDetails({
            FullName: "",
            EMailID: "",
            MobileNumber: "",
            City: "",
            Country: "",
            ProfilePicture: "",
          });
          resolve();
        })
        .catch(reject);
    });

  const checkAuth = () => {
    CheckAuthPromise().then(([_loggedIn, _userDetails]) => {
      setLoggedIn(_loggedIn);
      if (_loggedIn) {
        setUserDetails(_userDetails);
      } else {
        setUserDetails({
          FullName: "",
          EMailID: "",
          MobileNumber: "",
          City: "",
          Country: "",
          ProfilePicture: "",
        });
      }
    });
  };
  /* #endregion */

  useEffect(() => {
    checkAuth();
  }, []);
  return (
    <AuthContext.Provider
      value={{ loggedIn, userDetails, loginFunc, logoutFunc, sendCode }}
    >
      {children}
    </AuthContext.Provider>
  );
};
export { AuthContext };
export default AuthProvider;
